import { render, staticRenderFns } from "./AtlasLogo.vue?vue&type=template&id=706d8bdc&scoped=true&"
var script = {}
import style0 from "./AtlasLogo.vue?vue&type=style&index=0&id=706d8bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706d8bdc",
  null
  
)

export default component.exports